export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative mx-auto w-64 md:w-72">
              <div className="absolute inset-0 bg-gradient-to-b from-primary-500/30 to-accent-500/20 rounded-[2.5rem] blur-2xl"></div>
              <div className="relative rounded-[2.5rem] overflow-hidden border-4 border-foreground-900/80 shadow-xl bg-foreground-950">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20app%20interface%20mockup%20for%20video%20streaming%20platform%2C%20dark%20theme%20with%20warm%20amber%20accents%2C%20movie%20thumbnails%20grid%20layout%2C%20clean%20modern%20UI%20design%2C%20film%20posters%20browse%20screen%2C%20minimalist%20user%20interface%2C%20no%20text%20visible&width=600&height=1200&seq=app-mock-2026&orientation=portrait"
                  alt="大师兄影视移动端观影体验"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">随时随地 · 畅享观影</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              大师兄影视全面适配移动端，无论您使用手机还是平板，都能获得流畅的高清观影体验。支持离线缓存、倍速播放、投屏观看等实用功能，让您通勤路上、午休间隙都能轻松追剧。智能推荐算法根据您的观看偏好，精准推送您可能喜欢的影片。
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200">
                <div className="w-6 h-6 rounded bg-primary-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-primary-600 text-xs"></i>
                </div>
                <span className="text-sm text-foreground-700 whitespace-nowrap">iOS / Android</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200">
                <div className="w-6 h-6 rounded bg-accent-100 flex items-center justify-center">
                  <i className="ri-download-2-line text-accent-600 text-xs"></i>
                </div>
                <span className="text-sm text-foreground-700 whitespace-nowrap">离线缓存</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200">
                <div className="w-6 h-6 rounded bg-primary-100 flex items-center justify-center">
                  <i className="ri-cast-line text-primary-600 text-xs"></i>
                </div>
                <span className="text-sm text-foreground-700 whitespace-nowrap">投屏播放</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200">
                <div className="w-6 h-6 rounded bg-accent-100 flex items-center justify-center">
                  <i className="ri-speed-line text-accent-600 text-xs"></i>
                </div>
                <span className="text-sm text-foreground-700 whitespace-nowrap">倍速播放</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}